import { httpClient } from '../util/http-client'

export const deleteTrade = async ({ tradeId, domain }) => httpClient(`/trades/${tradeId}`, { domain, method: 'DELETE' })
